<template>
  <AuthLoadingPage v-if="isAuthenticating" />
  <AuthErrorPage v-else-if="authError" :message="authError" />
  <router-view v-else-if="isAuthenticated" />
</template>
<script>
  import { useI18n } from "vue-i18n"
  import AuthErrorPage from "@/components/AuthErrorPage.vue"
  import AuthLoadingPage from "@/components/AuthLoadingPage.vue"
  import { AuthManager } from "@/utils/authManager"
  import { BotConfig } from "@/utils/botConfig"

  export default {
    components: {
      AuthErrorPage,
      AuthLoadingPage,
    },
    setup() {
      const { locale } = useI18n()
      return { locale }
    },
    computed: {
      isAuthenticating() {
        return this.$store.getters.getIsAuthenticating
      },
      isAuthenticated() {
        return this.$store.getters.getIsAuthenticated
      },
      authError() {
        return this.$store.getters.getAuthError
      },
    },
    async mounted() {
      document.documentElement.setAttribute("data-theme", this.$store.getters.getTheme)
      this.locale = this.$store.getters.getLanguage

      this.$store.commit("setAuthenticating", true)
      this.$store.commit("clearAuth")

      const result = await AuthManager.validate()

      if (result.success) {
        BotConfig.persistBotId(result.botId)
        this.$store.commit("setTgUserData", result.user)
        this.$store.commit("setBotId", result.botId)
        if (result.balanceData) {
          this.$store.commit("setBalanceData", result.balanceData)
        }
        this.$store.commit("setAuthenticated", true)
        this.$store.commit("setAuthError", null)
      } else {
        this.$store.commit("setAuthError", result.error)
        this.$store.commit("setAuthenticated", false)
      }

      this.$store.commit("setAuthenticating", false)
    },
    watch: {
      "$store.state.language"(lang) {
        this.locale = lang
      },
    },
  }
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: var(--text-color1);
  }
  #tv-attr-logo {
    display: none !important;
  }
  nav {
    padding: 30px;
  }

  nav a {
    font-weight: bold;
    color: #2c3e50;
  }
  * {
    box-sizing: border-box;
    margin: 0;
    text-rendering: optimizeLegibility;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    -webkit-tap-highlight-color: transparent;
  }
  nav a.router-link-exact-active {
    color: #42b983;
  }
  p {
    font-family: "SF Pro Text";
    letter-spacing: -0.43px;
  }
  input {
    font-family: "SF Pro Text";
  }
  button {
    font-family: "SF Pro Text";
  }
  span {
    font-family: "SF Pro Text";
    letter-spacing: -0.43px;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.2s ease;
  }

  .fade-enter-from,
  .fade-leave-active {
    opacity: 0;
  }
  @font-face {
    font-family: "SF Pro Text";
    src: url("./assets/fonts/SFProText-Medium.ttf") format("truetype");
  }
  @font-face {
    font-family: "SF Pro Text Bold";
    src: url("./assets/fonts/SFProText-Semibold.ttf") format("truetype");
  }
  @font-face {
    font-family: "SF Compact Rounded";
    src: url("./assets/fonts/SF-Compact-Rounded-Regular.otf") format("truetype");
  }
  [data-theme="light"] {
    --background-color: #f1f0f6;
    --second-color: #ffffff;
    --button-background: #e5e6eb;
    --text-color1: #2c3e50;
    --text-color2: #1c2f4280;
    --text-color3: #2a2f35;
    --button-text-color: #ffffff;
    --black-to-white: #000000;
    --white-to-black: #ffffff;
    --hr-color: #1c2f420f;
    --slider-color: #ffffff;
    --deposit-color: #2a2f35;
    --competition-stop: #e5e6eb;
  }
  [data-theme="dark"] {
    --background-color: #1c1c1e;
    --second-color: #2c2c2e;
    --button-background: #2c2c2e;
    --text-color1: white;
    --text-color2: #ffffff80;
    --text-color3: #ffffff;
    --button-text-color: #ffffff;
    --black-to-white: #ffffff;
    --white-to-black: #191919;
    --hr-color: #424242;
    --slider-color: #1c1c1e;
    --deposit-color: #007aff;
    --competition-stop: #2c2c2e;
  }
</style>
